export default {
  getErrorCode(state) {
    return state.errorCode;
  },
  getRedirect(state) {
    return state.redirect;
  },
  getErrorType(state){
    return state.errorType;
  }
};
